const SIMPLE_USERNAME_PATTERN = /^[a-z0-9][a-z0-9._-]{2,63}$/;
const EMAIL_USERNAME_PATTERN = /^[a-z0-9][a-z0-9._%+-]{0,62}@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/;

export const ERP_USERNAME_MAX_LENGTH = 64;
export const ERP_USERNAME_HELP = 'Use de 3 a 64 caracteres ou informe um e-mail completo.';

export function normalizeErpUsername(value) {
  return String(value == null ? '' : value).normalize('NFKC').trim().toLowerCase();
}

export function isValidErpUsername(value) {
  const username = normalizeErpUsername(value);
  return username.length <= ERP_USERNAME_MAX_LENGTH
    && (SIMPLE_USERNAME_PATTERN.test(username) || EMAIL_USERNAME_PATTERN.test(username));
}
